<template lang="pug">
  .wq-wrapper
    .wq-family
      label {{question.family}}
      label {{question.subfamily}}
    .wq-right
      span.question {{question.question}}
      span.right Respuesta correcta: {{question.right_choice}}
    .wp-failed
      span(v-if="question.failed > 1") Falladas {{question.failed}} veces
      span(v-if="question.failed == 1") Fallada {{question.failed}} vez
</template>

<script type="text/javascript">
import utils from "@/service/utils";

export default {
  name: "WorstQuestion",
  props: ["question"],
  filters: {
    fixdecimal: function (value) {
      return utils.fixdecimal(value);
    },
  },
};
</script>
